import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAllList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .9,
			y: .9,
			width: 20.2,
			height: 20.2,
			rx: 5.1,
			stroke: "#161616",
			strokeWidth: 1.8
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 6.5H6.41667",
			stroke: "#161616",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.084 6.5H17.084",
			stroke: "#161616",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 11H6.41667",
			stroke: "#161616",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 15.5H6.41667",
			stroke: "#161616",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.084 11H14.6673",
			stroke: "#161616",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.084 15.5H17.084",
			stroke: "#161616",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		})
	]
});
export default SvgAllList;
